import { render, staticRenderFns } from "./Service14Table.vue?vue&type=template&id=964deee0&"
import script from "./Service14Table.vue?vue&type=script&lang=js&"
export * from "./Service14Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports